import f, { ODataFilterBuilder } from 'odata-filter-builder';
import { WorkflowEntityType } from '../../../types';
import { ODataUtils, escape, isEmpty } from '../../../utils';

import { IWorkflowSearchItems } from './types';

export const createWorkflowGridFilter = (
    { name, workflowTemplateUI, active, businessDocType, companyId }: Partial<IWorkflowSearchItems>,
    entityType: WorkflowEntityType
) => {
    const filterRules: ODataFilterBuilder[] = [];

    if (!isEmpty(name)) {
        filterRules.push(f().contains('name', escape(name!)));
    }

    if (typeof active === 'boolean') {
        filterRules.push(f().eq('active', active));
    }

    if (businessDocType) {
        filterRules.push(f().eq('businessDocType', businessDocType));
    }

    if (workflowTemplateUI) {
        filterRules.push(f().eq('workflowTemplateUI', workflowTemplateUI));
    }

    if (entityType) {
        filterRules.push(f().eq('EntityType', entityType));
    }

    if (companyId) {
        filterRules.push(f().eq('CompanyId', companyId));
    }

    return filterRules.length ? ODataUtils.andConditions(filterRules).toString() : undefined;
};
